import styled from 'styled-components';
import { STANDARD_HEADER_TOP_MARGIN } from '../utils/spacing';
import H3 from 'UIComponents/elements/headings/H3';
import MdxHeader from './MdxHeader';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledH3 = styled(H3).withConfig({
  displayName: "MdxH3__StyledH3",
  componentId: "sc-1b94be9-0"
})(["margin-top:", ";"], STANDARD_HEADER_TOP_MARGIN);
function MdxH3(props) {
  return /*#__PURE__*/_jsx(MdxHeader, Object.assign({
    Component: StyledH3
  }, props));
}
export default MdxH3;